// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\PaxRuleResponse

import { BookingRuleType } from './enums.gen';

export type PaxRuleApiResponse = {
	type: BookingRuleType.Pax;
	minPax: number | null;
	maxPax: number | null;
};

export type PaxRule = {
	type: BookingRuleType.Pax;
	minPax: number | null;
	maxPax: number | null;
};

export function hydratePaxRule(data: PaxRuleApiResponse): PaxRule {
	return { ...data };
}